export default __webpack_public_path__ + "static/media/profile_bg.896f754e.png";